module.exports = __webpack_public_path__ + "static/img/4.e866696.png";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/5/4.png
// module id = pms2
// module chunks = 14